import "./editor.css";
import $3V8v7$konva from "konva";
import $3V8v7$cytoscape from "cytoscape";
import {defaults as $3V8v7$defaults, get as $3V8v7$get, find as $3V8v7$find, matches as $3V8v7$matches, uniq as $3V8v7$uniq, uniqBy as $3V8v7$uniqBy, reject as $3V8v7$reject, isEmpty as $3V8v7$isEmpty, reduce as $3V8v7$reduce, countBy as $3V8v7$countBy, flatMap as $3V8v7$flatMap, defaultsDeep as $3V8v7$defaultsDeep, has as $3V8v7$has} from "lodash";
import $3V8v7$hotkeysjs from "hotkeys-js";
import {schemeSpectral as $3V8v7$schemeSpectral, schemeTableau10 as $3V8v7$schemeTableau10} from "d3-scale-chromatic";
import {scaleOrdinal as $3V8v7$scaleOrdinal} from "d3-scale";
import $3V8v7$hyperid from "hyperid";
import {readableColor as $3V8v7$readableColor} from "polished";
import $3V8v7$dagre from "dagre";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}




function $ddc0da5ca7921d57$var$createControls(editor) {
    const group = document.createElement("div");
    group.setAttribute("class", "editor__controls");
    const zoomIn = document.createElement("div");
    zoomIn.setAttribute("class", "controls__zoom controls__zoom--in");
    zoomIn.addEventListener("click", ()=>{
        editor.zoomIn();
    });
    const zoomOut = document.createElement("div");
    zoomOut.setAttribute("class", "controls__zoom controls__zoom--out");
    zoomOut.addEventListener("click", ()=>{
        editor.zoomOut();
    });
    group.append(zoomIn);
    group.append(zoomOut);
    return group;
}
var $ddc0da5ca7921d57$export$2e2bcd8739ae039 = $ddc0da5ca7921d57$var$createControls;




var $20432832efc00a88$exports = {};

$parcel$export($20432832efc00a88$exports, "BG_COLOR", function () { return $20432832efc00a88$export$78e3b94596623ae8; });
$parcel$export($20432832efc00a88$exports, "NODE_COLOR", function () { return $20432832efc00a88$export$146cb213c66e385a; });
$parcel$export($20432832efc00a88$exports, "LINE_COLOR", function () { return $20432832efc00a88$export$9369a7166d10a081; });
$parcel$export($20432832efc00a88$exports, "HANDLE_COLOR", function () { return $20432832efc00a88$export$c715a5aadabd11af; });
$parcel$export($20432832efc00a88$exports, "colorGenerator", function () { return $20432832efc00a88$export$78232bdf77d1cea6; });

const $20432832efc00a88$export$78e3b94596623ae8 = "#2c3e50";
const $20432832efc00a88$export$146cb213c66e385a = "#34495e";
const $20432832efc00a88$export$9369a7166d10a081 = "#7f8c8d";
const $20432832efc00a88$export$c715a5aadabd11af = "#B6C1C2";
function $20432832efc00a88$export$78232bdf77d1cea6(states) {
    // ordinal scale has to be between 3 and 11 in size
    const numColors = Math.max(3, Math.min(11, states.length));
    const trueFalse = Boolean(states[0].match(/true/i)) && Boolean(states[1].match(/false/i));
    if (trueFalse) return (index)=>[
            "#abdda4",
            "#d53e4f"
        ][index];
    return (index)=>(0, $3V8v7$schemeSpectral)[numColors][index % numColors];
}


var $22688a9b05d935c8$exports = {};

$parcel$export($22688a9b05d935c8$exports, "BG_COLOR", function () { return $22688a9b05d935c8$export$78e3b94596623ae8; });
$parcel$export($22688a9b05d935c8$exports, "NODE_COLOR", function () { return $22688a9b05d935c8$export$146cb213c66e385a; });
$parcel$export($22688a9b05d935c8$exports, "LINE_COLOR", function () { return $22688a9b05d935c8$export$9369a7166d10a081; });
$parcel$export($22688a9b05d935c8$exports, "HANDLE_COLOR", function () { return $22688a9b05d935c8$export$c715a5aadabd11af; });
$parcel$export($22688a9b05d935c8$exports, "HIGHLIGHT", function () { return $22688a9b05d935c8$export$73f7aa85b0021907; });
$parcel$export($22688a9b05d935c8$exports, "colorGenerator", function () { return $22688a9b05d935c8$export$78232bdf77d1cea6; });


const $22688a9b05d935c8$export$78e3b94596623ae8 = "#FDFDFD";
const $22688a9b05d935c8$export$146cb213c66e385a = "#FDFDFD";
const $22688a9b05d935c8$export$9369a7166d10a081 = "#D0D0D0";
const $22688a9b05d935c8$export$c715a5aadabd11af = "#D0D0D0";
const $22688a9b05d935c8$export$73f7aa85b0021907 = "#4894E8";
function $22688a9b05d935c8$export$78232bdf77d1cea6(states) {
    return (state)=>{
        if (state.match(/true/i)) return "#60D53E";
        if (state.match(/false/i)) return "#d53e4f";
        const scale = (0, $3V8v7$scaleOrdinal)().range((0, $3V8v7$schemeTableau10)).domain(states);
        return scale(state);
    };
}


let $5c131486cc14280c$var$theme = $20432832efc00a88$exports;
const $5c131486cc14280c$var$THEMES = {
    dark: $20432832efc00a88$exports,
    light: $22688a9b05d935c8$exports
};
function $5c131486cc14280c$export$89cbf1a0881c8b9c() {
    return $5c131486cc14280c$var$theme;
}
function $5c131486cc14280c$export$2e49b867b7a0847c(name) {
    $5c131486cc14280c$var$theme = $5c131486cc14280c$var$THEMES[name];
    return $5c131486cc14280c$var$theme;
}




const $31eaad3a3400f997$export$567fc7097e064344 = (0, $3V8v7$hyperid)({
    urlSafe: true
});
function $31eaad3a3400f997$export$6c41b80ded36ff33(startPost, endPos) {
    const { x: x1 , y: y1  } = startPost;
    const { x: x2 , y: y2  } = endPos;
    /**
   * add additional bezier control points for a nice curve
   *
   * cp1: x-coordinate is half-way node1 and node2;
   *  same y-coordinate as the first node
   * cp2: x-coordinate is half-way node1 and node2;
   *  same y-coorindate as the second node
   */ const xDiff = Math.max(x1, x2) - Math.min(x1, x2);
    const yDiff = Math.max(y1, y2) - Math.min(y1, y2);
    const toTheRight = x2 > x1;
    const below = y2 > y1;
    const toTheRightAndBelow = toTheRight && below;
    const toTheLeftAndBelow = !toTheRight && below;
    const toTheRightAndAbove = toTheRight && !below;
    const toTheLeftAndAbove = !toTheRight && !below;
    let controlPoint1, controlPoint2;
    if (toTheRightAndBelow || toTheRightAndAbove) {
        controlPoint1 = [
            x1 + xDiff / 2,
            y1
        ];
        controlPoint2 = [
            x1 + xDiff / 2,
            y2
        ];
    }
    if (toTheLeftAndBelow) {
        controlPoint1 = [
            x1 + xDiff / 2,
            y1 + yDiff / 2
        ];
        controlPoint2 = [
            x2 - xDiff / 2,
            y2 - yDiff / 2
        ];
    }
    if (toTheLeftAndAbove) {
        controlPoint1 = [
            x1 + Math.max(xDiff / 2, 10),
            y1
        ];
        controlPoint2 = [
            x2 - Math.max(xDiff / 2, 10),
            y2
        ];
    }
    return [
        x1,
        y1,
        ...controlPoint1,
        ...controlPoint2,
        x2,
        y2
    ];
}
function $31eaad3a3400f997$export$51134cce184326b9(event) {
    event.cancelBubble = true;
}
function $31eaad3a3400f997$export$ca17b14bf34aba4(node, cursor) {
    node.getStage().container().style.cursor = cursor;
}
/**
 * Get the absolute position of a node
 *
 * Correctly uses the scale transformation applied to the node
 * to calculate the correct coordinates
 */ function $31eaad3a3400f997$export$1e5457f4b876cb99(node) {
    const stage = node.getStage() || this.stage;
    return $31eaad3a3400f997$export$373663db9c61461e(stage, node.getAbsolutePosition());
}
function $31eaad3a3400f997$export$373663db9c61461e(stage, { x: x , y: y  }) {
    if (!stage) return null;
    const stageTransform = stage.getAbsoluteTransform().copy().invert();
    if (!stageTransform) return {
        x: x,
        y: y
    };
    const translated = stageTransform.getTranslation();
    const matrix = stageTransform.getMatrix();
    const scaleX = matrix[0];
    const scaleY = matrix[3];
    return {
        x: x * scaleX + translated.x,
        y: y * scaleY + translated.y
    };
}
/**
 * Get the actual client rect from a node, taking scaling into account on the Stage
 */ function $31eaad3a3400f997$export$b6aa1f30c53d7454(node) {
    const stageTransform = $31eaad3a3400f997$var$getStageTransform(node);
    if (!stageTransform) return node.getClientRect();
    const matrix = stageTransform.getMatrix();
    const scaleX = matrix[0];
    const scaleY = matrix[3];
    const { width: width , height: height  } = node.getClientRect();
    const position = $31eaad3a3400f997$export$1e5457f4b876cb99(node);
    return {
        ...position,
        width: width * scaleX,
        height: height * scaleY
    };
}
function $31eaad3a3400f997$var$getStageTransform(node) {
    const stage = node.getStage();
    if (!stage) return null;
    return stage.getAbsoluteTransform().copy().invert();
}
function $31eaad3a3400f997$export$1c9f709888824e05(nodes, layer) {
    const drawDebugLayer = (g, { color: color = "fuchsia"  })=>{
        const { x: x , y: y , width: width , height: height  } = g.getClientRect({
            relativeTo: layer
        });
        const rect = new (0, $3V8v7$konva).Rect({
            x: x,
            y: y,
            width: width,
            height: height,
            stroke: color,
            strokeWidth: 1
        });
        layer.add(rect);
        layer.getStage().add(layer);
    };
    nodes.forEach((g)=>{
        drawDebugLayer(g, {
            color: "fuchsia"
        });
    });
}






const $ec11ae0168317274$var$FONT_SIZE = 13;
const $ec11ae0168317274$var$PADDING = 8;
const { HANDLE_COLOR: $ec11ae0168317274$var$HANDLE_COLOR  } = (0, $5c131486cc14280c$export$89cbf1a0881c8b9c)();
const $ec11ae0168317274$var$ICON_SIZE = 28;
const $ec11ae0168317274$var$getIconSize = (icon)=>icon ? $ec11ae0168317274$var$ICON_SIZE : 0 // no icon = no space needed
;
var $ec11ae0168317274$export$2e2bcd8739ae039 = ({ label: label , description: description , icon: icon , content: content  }, { color: color  })=>{
    const { NODE_COLOR: NODE_COLOR  } = (0, $5c131486cc14280c$export$89cbf1a0881c8b9c)();
    const BG_COLOR = color || NODE_COLOR;
    const FONT_COLOR = (0, $3V8v7$readableColor)(BG_COLOR) // returns black or white
    ;
    // we'll be adding all children to this group
    const headGroup = new (0, $3V8v7$konva).Group({
        name: "head"
    });
    const textGroup = new (0, $3V8v7$konva).Group({
        name: "text"
    });
    if (label) {
        const title = new (0, $3V8v7$konva).Text({
            name: "label",
            text: label,
            fontSize: $ec11ae0168317274$var$FONT_SIZE,
            fontFamily: "monospace",
            fill: FONT_COLOR,
            opacity: 0.9
        });
        textGroup.add(title);
    }
    if (description) {
        const descriptionNode = new (0, $3V8v7$konva).Text({
            name: "description",
            text: description,
            fontSize: $ec11ae0168317274$var$FONT_SIZE * 0.8,
            fontFamily: "monospace",
            fill: FONT_COLOR,
            offsetY: -$ec11ae0168317274$var$FONT_SIZE * 1.1,
            opacity: 0.5
        });
        textGroup.add(descriptionNode);
    }
    if (content) {
        headGroup.add(content);
        const { width: contentWidth , height: contentHeight  } = content.getClientRect();
        headGroup.setAttrs({
            width: contentWidth,
            height: contentHeight
        });
    }
    const { width: width , height: height  } = textGroup.getClientRect();
    textGroup.setPosition({
        x: -width / 2,
        y: -height / 2
    });
    headGroup.add(textGroup);
    const { width: groupWidth , height: groupHeight  } = headGroup.getClientRect();
    const background = new (0, $3V8v7$konva).Rect({
        name: "background",
        fill: BG_COLOR,
        width: groupWidth + $ec11ae0168317274$var$PADDING * 2,
        height: groupHeight + $ec11ae0168317274$var$PADDING * 2,
        cornerRadius: 3,
        strokeWidth: 1,
        stroke: $ec11ae0168317274$var$HANDLE_COLOR
    });
    background.setPosition({
        x: -background.width() / 2,
        y: -background.height() / 2
    });
    headGroup.add(background);
    background.moveToBottom();
    headGroup.resize = $ec11ae0168317274$var$resize;
    if (icon) $ec11ae0168317274$var$loadIcon(headGroup, icon);
    return headGroup;
};
function $ec11ae0168317274$var$resize() {
    const background = this.findOne(".background");
    const textGroup = this.findOne(".text");
    const icon = this.findOne(".icon");
    const iconSize = $ec11ae0168317274$var$getIconSize(icon);
    const { width: textWidth , height: textHeight  } = (0, $31eaad3a3400f997$export$b6aa1f30c53d7454)(textGroup);
    const width = textWidth + $ec11ae0168317274$var$PADDING * 2 + iconSize * 2;
    const height = textHeight + $ec11ae0168317274$var$PADDING * 2;
    if (icon) {
        icon.setPosition({
            x: -(width / 2) + iconSize / 2
        });
        textGroup.setOffset({
            x: -(iconSize / 2)
        });
    }
    background.setSize({
        width: width,
        height: height
    });
    background.setPosition({
        x: -width / 2,
        y: -height / 2
    });
    textGroup.setPosition({
        x: -textWidth / 2,
        y: -textHeight / 2
    });
}
function $ec11ae0168317274$var$loadIcon(container, icon) {
    $ec11ae0168317274$var$loadImage(icon, (image)=>{
        const { width: width  } = (0, $31eaad3a3400f997$export$b6aa1f30c53d7454)(container);
        image.setAttrs({
            name: "icon",
            x: -(width / 2) + $ec11ae0168317274$var$ICON_SIZE / 2,
            y: 0,
            offsetX: 0,
            offsetY: $ec11ae0168317274$var$ICON_SIZE / 2,
            width: $ec11ae0168317274$var$ICON_SIZE,
            height: $ec11ae0168317274$var$ICON_SIZE
        });
        container.add(image).draw();
        // re-draw entire stage to get around a weird z-index bug
        container.getStage().draw();
        // notify the head we are done
        container.fire("iconAdded");
    });
}
/**
 * This is pretty much the same as Image.fromURL
 * but without the CORS headers.
 *
 * This is necessary because of https://github.com/waylayio/console/issues/101
 */ function $ec11ae0168317274$var$loadImage(url, callback) {
    const img = (0, $3V8v7$konva).Util.createImageElement();
    img.onload = function() {
        const image = new (0, $3V8v7$konva).Image({
            image: img
        });
        callback(image);
    };
    img.src = url;
}





const $79a5aa7bbe1c4e99$var$ICON_SIZE = 13;
const $79a5aa7bbe1c4e99$var$ICON_MARGIN = 4;
const $79a5aa7bbe1c4e99$var$FONT_SIZE = 10;
var $79a5aa7bbe1c4e99$export$2e2bcd8739ae039 = (details, container)=>{
    const annotationsGroup = new (0, $3V8v7$konva).Group({
        name: "annotations"
    });
    const labelsGroup = new (0, $3V8v7$konva).Group({
        name: "nodeLabels"
    });
    const { annotations: annotations = [] , labels: labels = []  } = details;
    if (annotations.length > 0) annotations.forEach((imgSrc)=>$79a5aa7bbe1c4e99$var$createImage(imgSrc, annotationsGroup));
    if (labels.length > 0) $79a5aa7bbe1c4e99$var$createLabels(labels, labelsGroup);
    const { width: width , height: height  } = container.getClientRect();
    // set annotations group position
    annotationsGroup.setPosition({
        x: width / 2,
        y: -height / 2
    });
    // set labels group position
    labelsGroup.setPosition({
        x: -(width / 2) + $79a5aa7bbe1c4e99$var$FONT_SIZE / 2,
        y: -(height / 2) - $79a5aa7bbe1c4e99$var$FONT_SIZE * 1.5
    });
    return [
        annotationsGroup,
        labelsGroup
    ];
};
function $79a5aa7bbe1c4e99$var$placeInRow(nodes, options = {}) {
    const { margin: margin = 0 , direction: direction = "ltr"  } = options;
    nodes.forEach((node, index)=>{
        const width = node.width();
        const xPos = direction === "ltr" ? 0 + width * index + margin * index : 0 - width * index - margin * index;
        node.setX(xPos);
    });
}
function $79a5aa7bbe1c4e99$var$createLabels(labels, group) {
    const { BG_COLOR: BG_COLOR  } = (0, $5c131486cc14280c$export$89cbf1a0881c8b9c)();
    const node = new (0, $3V8v7$konva).Text({
        text: labels.join(", "),
        fontSize: $79a5aa7bbe1c4e99$var$FONT_SIZE,
        fontFamily: "monospace",
        fill: (0, $3V8v7$readableColor)(BG_COLOR),
        opacity: 0.5
    });
    group.add(node);
}
function $79a5aa7bbe1c4e99$var$createImage(src, container) {
    (0, $3V8v7$konva).Image.fromURL(src, (image)=>{
        image.setAttrs({
            offsetX: $79a5aa7bbe1c4e99$var$ICON_SIZE / 2,
            offsetY: $79a5aa7bbe1c4e99$var$ICON_SIZE / 2,
            width: $79a5aa7bbe1c4e99$var$ICON_SIZE,
            height: $79a5aa7bbe1c4e99$var$ICON_SIZE
        });
        container.add(image);
        $79a5aa7bbe1c4e99$var$placeInRow(container.children, {
            margin: $79a5aa7bbe1c4e99$var$ICON_MARGIN,
            direction: "rtl"
        });
        container.draw();
    });
}







const $c17607a58ba3b426$var$DEFAULTS = {
    name: "edge",
    strokeWidth: 2,
    lineCap: "round",
    bezier: true,
    opacity: 0.6,
    shadowBlur: 5,
    shadowOpacity: 0.8,
    shadowEnabled: false,
    hitStrokeWidth: 5,
    zIndex: 1
};
class $c17607a58ba3b426$var$Curve extends (0, $3V8v7$konva).Line {
    constructor(startHandle, endHandle, options = {
        style: {}
    }, data = {}){
        const { LINE_COLOR: LINE_COLOR  } = (0, $5c131486cc14280c$export$89cbf1a0881c8b9c)();
        const stage = startHandle.getStage();
        const { editor: editor  } = options;
        // getStroke is used here because it can be unedfined for non-state nodes
        // so we need to fallback to LINE_COLOR then
        const startHandleColor = options.color || startHandle.getStroke() || LINE_COLOR;
        const endHandleColor = options.color || endHandle.getStroke() || LINE_COLOR;
        const pos1 = (0, $31eaad3a3400f997$export$1e5457f4b876cb99)(startHandle);
        const pos2 = (0, $31eaad3a3400f997$export$1e5457f4b876cb99).bind({
            stage: stage
        })(endHandle);
        const bezierPoints = (0, $31eaad3a3400f997$export$6c41b80ded36ff33)(pos1, pos2);
        const optionsWithDefaults = Object.assign($c17607a58ba3b426$var$DEFAULTS, options.styles, {
            stroke: startHandleColor,
            shadowColor: startHandleColor
        }, {
            points: bezierPoints
        });
        // default construtor
        super(optionsWithDefaults);
        // add new handlers
        this.editor = editor;
        this.startHandle = startHandle;
        this.endHandle = endHandle;
        // save colors of handles
        this.startHandleColor = startHandleColor;
        this.endHandleColor = endHandleColor;
        // make this conform to an edge
        this.data = ()=>{
            return {
                source: this.startHandle.findAncestor(".node").attrs.id,
                target: this.endHandle.findAncestor(".node").attrs.id,
                strokeWidth: 2,
                ...data,
                states: startHandle.state ? [
                    startHandle.state
                ] : [
                    "*"
                ]
            };
        };
        this.selected = false;
        this.on("mousedown", this._mouseDownHandler);
        this.on("mouseover", this._mouseOver);
        this.on("mouseout", this._mouseOut);
    }
    _mouseOver() {
        if (this.selected) return;
        this.shadowEnabled(true);
        this.getStage().draw();
    }
    _mouseOut() {
        this.shadowEnabled(false);
        this.getStage().draw();
    }
    _mouseDownHandler({ evt: { ctrlKey: ctrlKey , metaKey: metaKey , shiftKey: shiftKey  }  }) {
        const multiSelectModeRequested = ctrlKey || metaKey || shiftKey;
        const alreadySelected = Boolean(this.editor.getSelectedCurves().find(({ _id: _id  })=>_id === this._id));
        if (!alreadySelected) {
            if (!multiSelectModeRequested) // disable previous selection
            this.editor._unselect(null);
            this.setSelected(true);
            return true;
        }
        if (multiSelectModeRequested) this.setSelected(false);
        return this;
    }
    getParentEdge() {
        const startNode = this.startHandle.findAncestor(".node");
        const endNode = this.endHandle.findAncestor(".node");
        if (startNode && endNode) return this.editor.findEdge(startNode.attrs.id, endNode.attrs.id);
        return undefined;
    }
    getId() {
        return this._id;
    }
    setId(id) {
        this._id = id;
    }
    setSelected(selected) {
        const { HIGHLIGHT: HIGHLIGHT  } = (0, $5c131486cc14280c$export$89cbf1a0881c8b9c)();
        const color = selected ? HIGHLIGHT : this.startHandleColor;
        const startHandleColor = selected ? HIGHLIGHT : this.startHandleColor;
        const endHandleColor = selected ? HIGHLIGHT : this.endHandleColor;
        const isStateStart = Boolean(this.startHandle.state);
        const isStateEnd = Boolean(this.endHandle.state);
        this.selected = selected;
        if (selected) this.editor._selectCurve(this);
        else this.editor._unselectCurve(this);
        this.stroke(color);
        if (this.startHandle) {
            this.startHandle.fill(startHandleColor);
            this.startHandle.strokeWidth(isStateStart ? 2 : 0);
            this.startHandle.stroke(startHandleColor);
        }
        if (this.endHandle) {
            this.endHandle.fill(endHandleColor);
            this.endHandle.strokeWidth(isStateEnd ? 2 : 0);
            this.endHandle.stroke(endHandleColor);
        }
    }
}
var $c17607a58ba3b426$export$2e2bcd8739ae039 = $c17607a58ba3b426$var$Curve;




const $1500750721adc37e$var$HANDLE_SIZE = 10;
function $1500750721adc37e$export$b8e82d48a5df8c5a(shape, { editor: editor  }) {
    const { HANDLE_COLOR: HANDLE_COLOR  } = (0, $5c131486cc14280c$export$89cbf1a0881c8b9c)();
    const { width: width  } = shape.getClientRect();
    const leftHandle = new (0, $3V8v7$konva).Circle({
        name: "leftHandle",
        radius: $1500750721adc37e$var$HANDLE_SIZE / 2,
        x: -(width / 2),
        fill: HANDLE_COLOR,
        zIndex: 99
    });
    const rightHandle = new (0, $3V8v7$konva).Circle({
        name: "rightHandle",
        x: width / 2,
        radius: $1500750721adc37e$var$HANDLE_SIZE / 2,
        fill: HANDLE_COLOR,
        zIndex: 99
    });
    if (editor._options.editable) $1500750721adc37e$export$417a3e320db257c3(leftHandle, rightHandle);
    return [
        leftHandle,
        rightHandle
    ];
}
function $1500750721adc37e$export$417a3e320db257c3(...handles) {
    handles.forEach((handle)=>{
        handle.on("mouseenter", ()=>(0, $31eaad3a3400f997$export$ca17b14bf34aba4)(handle, "crosshair"));
        handle.on("mouseleave", ()=>(0, $31eaad3a3400f997$export$ca17b14bf34aba4)(handle, "default"));
        handle.on("mousedown", $1500750721adc37e$var$onMouseDown);
        handle.on("mousedown", (0, $31eaad3a3400f997$export$51134cce184326b9));
    });
}
function $1500750721adc37e$var$onMouseDown({ target: target  }) {
    const { state: state = "*"  } = target;
    const stage = target.getStage();
    stage.setDraggable(false);
    stage.setSelected(null);
    const sourceNode = target.findAncestor(".node");
    const startHandle = state ? sourceNode.getStateHandle(state) : sourceNode.getRightHandle();
    const startHandlePos = (0, $31eaad3a3400f997$export$1e5457f4b876cb99)(startHandle);
    const endHandlePos = stage.getAbsolutePointerPosition();
    const endHandle = new (0, $3V8v7$konva).Circle({
        position: endHandlePos
    });
    const curve = new (0, $c17607a58ba3b426$export$2e2bcd8739ae039)(startHandle, endHandle);
    const [layer] = stage.find("Layer");
    if (layer) layer?.add(curve);
    // attach curve to cursor
    stage.on("mousemove", (event)=>{
        const endHandlePos = stage.getAbsolutePointerPosition();
        const points = (0, $31eaad3a3400f997$export$6c41b80ded36ff33)(startHandlePos, endHandlePos);
        /**
     * the actual line needs to "lag behind" the cursor or the "mouseup"
     * event will detect the line itself and not the actual target, so we're
     * offsetting the x coordinate on the final point
     */ points[6] = points[6] - 4;
        curve.setPoints(points);
        stage.batchDraw();
    });
    stage.on("mouseup", onMouseUp.bind(this));
    function onMouseUp(event) {
        stage.off("mouseup mousemove") // stop listening to move events
        ;
        stage.setDraggable(true);
        const target = event.target;
        const targetNode = target.findAncestor(".node");
        if (targetNode) stage.connectNodes(sourceNode.id(), targetNode.id(), state);
        else if (state) sourceNode.deactivateState(state);
        curve.off();
        curve.destroy();
        // one final draw() after destroying the curve
        stage.draw();
    }
}




const $cc37e3f0f6e0e3d8$var$HANDLE_RADIUS = 4;
const $cc37e3f0f6e0e3d8$var$INACTIVE = 0.3;
const $cc37e3f0f6e0e3d8$var$ACTIVE = 1;
const $cc37e3f0f6e0e3d8$var$BG_INACTIVE = 0.15;
const $cc37e3f0f6e0e3d8$var$BG_ACTIVE = 0.4;
var $cc37e3f0f6e0e3d8$export$2e2bcd8739ae039 = (states = [], options = {})=>{
    // we're adding all children to this group
    const group = new (0, $3V8v7$konva).Group({
        name: "states"
    });
    const generateColor = $cc37e3f0f6e0e3d8$var$colorGenerator(states);
    const stateItems = $cc37e3f0f6e0e3d8$var$placeInColumn(states.map((state, index)=>{
        const color = generateColor(state);
        return createStateItem(state, color, options);
    }), {
        margin: -6
    });
    group.add(...stateItems);
    function createStateItem(state, color) {
        const group = new (0, $3V8v7$konva).Group({
            name: `stategroup:${encodeURIComponent(state)}`
        });
        const text = new (0, $3V8v7$konva).Text({
            text: state,
            fill: color,
            opacity: group.isConnected ? $cc37e3f0f6e0e3d8$var$ACTIVE : $cc37e3f0f6e0e3d8$var$INACTIVE
        });
        const handle = new (0, $3V8v7$konva).Circle({
            name: `state:${encodeURIComponent(state)}`,
            fill: group.isConnected ? color : null,
            stroke: color,
            radius: $cc37e3f0f6e0e3d8$var$HANDLE_RADIUS,
            x: text.width() + $cc37e3f0f6e0e3d8$var$HANDLE_RADIUS * 2.5,
            y: text.height() / 2,
            opacity: group.isConnected ? $cc37e3f0f6e0e3d8$var$ACTIVE : $cc37e3f0f6e0e3d8$var$INACTIVE
        });
        const focusRectangle = new (0, $3V8v7$konva).Rect({
            fillEnabled: false,
            strokeEnabled: false,
            fill: color,
            cornerRadius: 12,
            opacity: group.isConnected ? $cc37e3f0f6e0e3d8$var$BG_ACTIVE : $cc37e3f0f6e0e3d8$var$BG_INACTIVE
        });
        // activate this state, making the text and handle appear active
        group.activate = function() {
            handle.setAttrs({
                opacity: $cc37e3f0f6e0e3d8$var$ACTIVE,
                fill: color
            });
            text.setAttrs({
                opacity: $cc37e3f0f6e0e3d8$var$ACTIVE
            });
            focusRectangle.setAttrs({
                opacity: $cc37e3f0f6e0e3d8$var$BG_ACTIVE
            });
            handle.getStage().draw();
            group.isConnected = true;
        };
        // deactivate this state, making the text and handle appear inactive
        group.deactivate = function() {
            handle.setAttrs({
                opacity: $cc37e3f0f6e0e3d8$var$INACTIVE,
                fill: null
            });
            text.setAttrs({
                opacity: $cc37e3f0f6e0e3d8$var$INACTIVE
            });
            focusRectangle.setAttrs({
                opacity: $cc37e3f0f6e0e3d8$var$BG_INACTIVE
            });
            handle.getStage().draw();
            group.isConnected = false;
        };
        group.hover = function() {
            handle.setAttrs({
                opacity: $cc37e3f0f6e0e3d8$var$ACTIVE,
                fill: null
            });
            text.setAttrs({
                opacity: $cc37e3f0f6e0e3d8$var$ACTIVE
            });
            handle.getStage().draw();
        };
        group.focus = function() {
            focusRectangle.fillEnabled(true);
        };
        group.unfocus = function() {
            focusRectangle.fillEnabled(false);
        };
        function onMouseOver(event) {
            if (group.isConnected) return;
            group.hover();
            handle.on("mouseout", (e)=>onMouseOut(e));
        }
        function onMouseOut() {
            handle.off("mouseout");
            if (!group.isConnected) group.deactivate();
        }
        handle.state = state;
        group.add(focusRectangle, text, handle);
        // set focus rectangle size equal to the group size
        const { width: width , height: height  } = (0, $31eaad3a3400f997$export$b6aa1f30c53d7454)(group);
        // these numbers are the paddings and corrections for paddings
        focusRectangle.setAttrs({
            width: width + 15,
            height: height + 10,
            x: -9,
            y: -5
        });
        if (options.editor._options.editable) {
            handle.on("mouseover", (e)=>onMouseOver(e));
            handle.on("mousedown mouseup", ()=>{
                handle.off("mouseout");
                handle.getStage().setSelected(null);
            });
            handle.on("mousedown", ()=>{
                if (group.isConnected) return;
                group.activate();
            });
            handle.on("mouseup", ()=>{
                if (group.isConnected) return;
                group.deactivate();
            });
            (0, $1500750721adc37e$export$417a3e320db257c3)(group);
        }
        return group;
    }
    return group;
};
function $cc37e3f0f6e0e3d8$var$placeInColumn(nodes, options = {}) {
    const { margin: margin = 0  } = options;
    const widestNode = Math.max(...nodes.map((n)=>(0, $31eaad3a3400f997$export$b6aa1f30c53d7454)(n).width));
    nodes.forEach((node, index)=>{
        const { width: width , height: height  } = (0, $31eaad3a3400f997$export$b6aa1f30c53d7454)(node);
        const newY = height * index + index * margin;
        const newX = widestNode - width;
        node.setPosition({
            y: newY,
            x: newX
        });
    });
    return nodes;
}
// select color palette based on number of states
function $cc37e3f0f6e0e3d8$var$colorGenerator(states) {
    const { colorGenerator: colorGenerator  } = (0, $5c131486cc14280c$export$89cbf1a0881c8b9c)();
    // ordinal scale has to be between 3 and 11 in size
    const colors = colorGenerator(states);
    return (state)=>colors(state);
}



const $e2813256b5c7265c$var$DEFAULTS = {
    name: "node",
    draggable: false // dragging should always happen through a group
};
class $e2813256b5c7265c$var$GraphNode extends (0, $3V8v7$konva).Group {
    constructor(data = {}, options = {}){
        const optionsWithDefaults = Object.assign($e2813256b5c7265c$var$DEFAULTS, options, {
            id: data.id
        });
        super(optionsWithDefaults);
        this.data = data;
        this.options = optionsWithDefaults;
        this.drawNode(data);
        // we have to clear the internal Konva cache after drawing the node for some reason
        this.clearCache();
        return this;
    }
    updateData(key, value) {
        const id = this.id();
        this.options.editor.updateElementData(id, {
            [key]: value
        });
        this.data[key] = value;
    }
    moveTo(position) {
        this.position(position);
        this.updateEdges();
    }
    updateEdges() {
        this.getEdges().forEach((edge)=>{
            const curves = edge.data("curves") || [];
            curves.forEach((curve)=>{
                const { startHandle: startHandle , endHandle: endHandle  } = curve;
                const bezierPoints = (0, $31eaad3a3400f997$export$6c41b80ded36ff33)((0, $31eaad3a3400f997$export$1e5457f4b876cb99)(startHandle), (0, $31eaad3a3400f997$export$1e5457f4b876cb99)(endHandle));
                curve.setPoints(bezierPoints);
            });
        });
    }
    getRightHandle() {
        return this.findOne(".rightHandle");
    }
    getLeftHandle() {
        return this.findOne(".leftHandle");
    }
    getStateHandle(state) {
        const stateGroup = this.getStateGroup(state);
        return stateGroup ? stateGroup.findOne(`.state:${encodeURIComponent(state)}`) : this.getRightHandle();
    }
    getStateGroup(state) {
        return this.findOne(`.stategroup:${encodeURIComponent(state)}`);
    }
    activateState(state) {
        const group = this.getStateGroup(state);
        if (group) group.activate();
    }
    deactivateState(state) {
        // check if other edges are still connected to this state
        const connectedStates = this.getConnectedStates();
        const counts = (0, $3V8v7$countBy)(connectedStates);
        if (counts[state] > 1) return;
        const group = this.getStateGroup(state);
        if (group) group.deactivate();
    }
    getEdges(filter) {
        const { graph: graph  } = this.options.editor;
        const { id: id  } = this.data;
        return graph.getElementById(id).connectedEdges(filter);
    }
    hasConnectedState(state) {
        return this.getConnectedStatesUnique().includes(state);
    }
    getConnectedStatesUnique() {
        return (0, $3V8v7$uniq)(this.getConnectedStates());
    }
    getConnectedStates() {
        const { id: id  } = this.data;
        const edges = this.getEdges(`[source="${id}"]`);
        return (0, $3V8v7$flatMap)(edges, (e)=>e.data("states"));
    }
    updateLabel(value) {
        this.updateProp("label", value);
        this.updateData("label", value);
    }
    updateNodeLabels(labels) {
        const element = this.findOne(".nodeLabels");
        if (!element) {
            const err = new Error("no nodeLabels found");
            throw Object.assign(err, {
                data: this.data
            });
        }
        element.destroy();
        this.add((0, $79a5aa7bbe1c4e99$export$2e2bcd8739ae039)({
            labels: labels
        }, this.findOne(".head"))[1]);
        this.data.labels = labels;
        this.resize();
    }
    addAnnotation(annotation) {
        const { data: { annotations: annotations = []  }  } = this;
        annotations.push(annotation);
        const element = this.findOne(".annotations");
        if (element) {
            element.destroy();
            this.add((0, $79a5aa7bbe1c4e99$export$2e2bcd8739ae039)({
                annotations: annotations
            }, this.findOne(".head"))[0]);
            this.resize();
        }
    }
    deleteAnnotation(annotation) {
        const { data: { annotations: annotations = []  }  } = this;
        const index = annotations.indexOf(annotation);
        if (index < 0) return;
        annotations.splice(index, 1);
        const element = this.findOne(".annotations");
        element.destroy();
        this.add((0, $79a5aa7bbe1c4e99$export$2e2bcd8739ae039)({
            annotations: annotations
        }, this.findOne(".head"))[0]);
        this.resize();
    }
    updateProp(key, value) {
        const element = this.findOne(`.${key}`);
        if (!element) {
            const err = new Error(`no such prop to update: "${key}"`);
            throw Object.assign(err, {
                data: this.data
            });
        }
        element.text(value);
        this.resize();
    }
    resize() {
        const head = this.findOne(".head");
        head.resize();
        const { width: width  } = (0, $31eaad3a3400f997$export$b6aa1f30c53d7454)(head);
        const labels = this.findOne(".nodeLabels");
        const annotations = this.findOne(".annotations");
        const states = this.findOne(".states");
        if (labels) labels.setX(-width / 2);
        if (annotations) annotations.setX(width / 2);
        if (states) {
            const { width: statesWidth  } = (0, $31eaad3a3400f997$export$b6aa1f30c53d7454)(states);
            states.setX(width / 2 - statesWidth);
        }
        const leftHandle = this.getLeftHandle();
        const rightHandle = this.getRightHandle();
        if (leftHandle) leftHandle.setX(-width / 2);
        if (rightHandle) rightHandle.setX(width / 2);
        this.updateEdges();
        const editor = this.options.editor;
        editor.batchDraw();
    }
    drawNode() {
        const { data: data , options: options  } = this;
        const { states: states = []  } = data;
        const editor = options.editor;
        const head = (0, $ec11ae0168317274$export$2e2bcd8739ae039)(data, options);
        head.on("iconAdded", ()=>this.resize());
        this.add(head);
        if (states.length > 0) {
            const statesGroup = (0, $cc37e3f0f6e0e3d8$export$2e2bcd8739ae039)(data.states, {
                editor: editor
            });
            const { height: height , width: width  } = this.getClientRect();
            // align right and flow to the left
            statesGroup.setPosition({
                x: width / 2 - statesGroup.getClientRect().width,
                y: height / 2 + 10
            });
            this.add(statesGroup);
        }
        const handles = (0, $1500750721adc37e$export$b8e82d48a5df8c5a)(head, {
            editor: editor
        });
        $e2813256b5c7265c$var$addHandles(this, data, handles);
        const annotations = (0, $79a5aa7bbe1c4e99$export$2e2bcd8739ae039)(data, head);
        this.add(...annotations);
        return this;
    }
    toggleSelected() {
        this.setSelected(!this.options.selected);
    }
    setSelected(selected) {
        const { HANDLE_COLOR: HANDLE_COLOR , HIGHLIGHT: HIGHLIGHT  } = (0, $5c131486cc14280c$export$89cbf1a0881c8b9c)();
        const background = this.findOne(".background");
        if (!background) return;
        if (selected) {
            background.stroke(HIGHLIGHT);
            background.strokeWidth(2);
        } else {
            background.stroke(HANDLE_COLOR);
            background.strokeWidth(1);
        }
        background.getStage().draw();
        this.options.selected = !selected;
    }
    unfocus() {
        this.opacity(0.25);
        this.unfocusEdges();
    }
    unfocusEdges() {
        const { id: id  } = this.data;
        const { graph: graph  } = this.options.editor;
        const parentEdges = this.getEdges(`[target="${id}"]`);
        const gNode = graph.getElementById(id);
        const focused = gNode.data("focused");
        if (!focused) parentEdges.forEach((edge)=>{
            const curves = edge.data("curves") || [];
            curves.forEach((curve)=>curve.unfocus());
        });
    }
    focus() {
        this.opacity(1);
        const { id: id  } = this.data;
        const parentEdges = this.getEdges(`[target="${id}"]`);
        parentEdges.forEach((edge)=>{
            const source = edge.source();
            const curves = edge.data("curves") || [];
            if (source.data("focused")) curves.forEach((curve)=>curve.focus());
        });
    }
    focusState(state) {
        const group = this.getStateGroup(state);
        group.focus();
    }
    unfocusState(state) {
        const group = this.getStateGroup(state);
        group.unfocus();
    }
}
function $e2813256b5c7265c$var$addHandles(group, data, handles) {
    const { type: type  } = data;
    const [leftHandle, rightHandle] = handles;
    if (type === "actuator") {
        group.add(leftHandle);
        return;
    }
    group.add(leftHandle, rightHandle);
}
var $e2813256b5c7265c$export$2e2bcd8739ae039 = $e2813256b5c7265c$var$GraphNode;








const $9e34bb6b5aa61405$var$GATE_TYPES = [
    "AND",
    "NAND",
    "OR",
    "GENERAL"
];
const $9e34bb6b5aa61405$var$FONT_SIZE = 13;
const $9e34bb6b5aa61405$var$gateLabels = {
    AND: "AND",
    NAND: "NAND",
    OR: "OR",
    GENERAL: "GEN"
};
class $9e34bb6b5aa61405$var$Gate extends (0, $e2813256b5c7265c$export$2e2bcd8739ae039) {
    drawNode() {
        const { gateType: gateType  } = this.data;
        const { editor: editor  } = this.options;
        const typeExists = $9e34bb6b5aa61405$var$GATE_TYPES.includes(gateType);
        if (!typeExists) throw new Error(`No such gate: ${gateType}`);
        const gate = $9e34bb6b5aa61405$var$createGate({
            label: $9e34bb6b5aa61405$var$gateLabels[gateType]
        });
        this.add(gate);
        const handles = (0, $1500750721adc37e$export$b8e82d48a5df8c5a)(gate, {
            editor: editor
        });
        this.add(...handles);
        const statesGroup = (0, $cc37e3f0f6e0e3d8$export$2e2bcd8739ae039)([
            "TRUE",
            "FALSE"
        ], {
            editor: editor
        });
        const statesGroupSize = statesGroup.getClientRect();
        const padding = 5;
        statesGroup.position({
            x: -statesGroupSize.width / 2 + padding,
            y: statesGroupSize.height + padding
        });
        this.add(statesGroup);
        return this;
    }
    setSelected(selected) {
        const { HANDLE_COLOR: STROKE_COLOR , HIGHLIGHT: HIGHLIGHT  } = (0, $5c131486cc14280c$export$89cbf1a0881c8b9c)();
        const background = this.findOne(".background");
        if (!background) return;
        if (selected) background.setAttrs({
            stroke: HIGHLIGHT,
            strokeWidth: 2
        });
        else background.setAttrs({
            stroke: STROKE_COLOR,
            strokeWidth: 1
        });
        background.moveToBottom();
        background.getStage().draw();
        this.options.selected = !selected;
    }
}
function $9e34bb6b5aa61405$var$createGate(details) {
    const { NODE_COLOR: NODE_COLOR , HANDLE_COLOR: HANDLE_COLOR  } = (0, $5c131486cc14280c$export$89cbf1a0881c8b9c)();
    const TEXT_COLOR = (0, $3V8v7$readableColor)(NODE_COLOR);
    const { label: label = "GATE"  } = details;
    const group = new (0, $3V8v7$konva).Group() // adding elements to this group
    ;
    const text = new (0, $3V8v7$konva).Text({
        text: label,
        fontSize: $9e34bb6b5aa61405$var$FONT_SIZE,
        fontFamily: "monospace",
        fill: TEXT_COLOR,
        padding: 15
    });
    const { width: textWidth , height: textHeight  } = text.getClientRect();
    text.setAttrs({
        offsetX: textWidth / 2,
        offsetY: textHeight / 2,
        y: textHeight / 2
    });
    group.add(text);
    group.setAttrs({
        offsetY: textHeight / 2
    });
    const background = new (0, $3V8v7$konva).Circle({
        name: "background",
        radius: Math.max(textWidth, textHeight) / 2,
        fill: NODE_COLOR,
        offsetY: -(textHeight / 2),
        stroke: HANDLE_COLOR,
        strokeWidth: 1
    });
    group.on("mouseenter", ()=>{
        group.getStage().container().style.cursor = "move";
    });
    group.on("mouseleave", ()=>{
        group.getStage().container().style.cursor = "default";
    });
    group.add(background);
    background.moveToBottom();
    return group;
}
var $9e34bb6b5aa61405$export$2e2bcd8739ae039 = $9e34bb6b5aa61405$var$Gate;





const $89a453f9fbb0c932$var$defaults = {
    style: {
        color: "#feca57"
    }
};
class $89a453f9fbb0c932$var$Note extends (0, $e2813256b5c7265c$export$2e2bcd8739ae039) {
    constructor(data, options){
        super({
            ...data,
            type: "INFO"
        }, (0, $3V8v7$defaultsDeep)(options, $89a453f9fbb0c932$var$defaults));
    }
    drawNode() {
        const { data: data , options: options  } = this;
        const { style: style , position: position = {
            x: 0,
            y: 0
        }  } = options;
        const head = (0, $ec11ae0168317274$export$2e2bcd8739ae039)(data, style);
        this.add(head);
        this.setPosition(position);
        return this;
    }
}
var $89a453f9fbb0c932$export$2e2bcd8739ae039 = $89a453f9fbb0c932$var$Note;



var $bee1458cde2e54d0$export$2e2bcd8739ae039 = (baseLayer, editor)=>{
    const moveNodeRelative = (node, { x: x , y: y  })=>{
        const position = {
            x: node.x() + x,
            y: node.y() + y
        };
        node.position(position);
        editor.updateElementPosition(node.id(), position);
    };
    const dragMoveHandler = ()=>group.getChildren().forEach((c)=>c.updateEdges());
    const dragEndHandler = ({ target: target  })=>{
        const pos = target.position();
        // Eliminate floating point coordinates
        const [x, y] = [
            "x",
            "y"
        ].map((k)=>Math.round(pos[k]));
        const children = group.getChildren();
        children.forEach((c)=>moveNodeRelative(c, {
                x: x,
                y: y
            }));
        group.position({
            x: 0,
            y: 0
        });
        // we remove the dragStart operation and replace it with the drag operation
        //   const dragStart = editor.history.changes.pop()
        editor.history.push({
            op: "drag",
            undo: ()=>{
                children.forEach((c)=>{
                    moveNodeRelative(c, {
                        x: -x,
                        y: -y
                    });
                    c.updateEdges();
                });
                editor.draw();
            },
            redo: ()=>{
                children.forEach((c)=>{
                    moveNodeRelative(c, {
                        x: x,
                        y: y
                    });
                    c.updateEdges();
                });
                editor.draw();
            }
        });
    };
    const group = new (0, $3V8v7$konva).Group({
        name: "selectionGroup",
        draggable: false,
        listening: false
    });
    // dragmove -> update linked nodes and bezier lines
    group.on("dragmove", dragMoveHandler);
    group.on("dragend", dragEndHandler);
    group.on("mouseenter", ()=>group.getStage().container().style.cursor = "move");
    group.on("mouseleave", ()=>group.getStage().container().style.cursor = "default");
    baseLayer.add(group);
    return group;
};




var $a209bedd1febcc34$exports = {};
const $a209bedd1febcc34$var$defaults = {
    // dagre algo options, uses default value on undefined
    nodesep: 50,
    edgesep: 20,
    ranksep: 50,
    rankdir: "LR",
    ranker: "longest-path",
    // Possible values: network-simplex, tight-tree or longest-path
    minLen: 1,
    edgeWeight: 1 // higher weight edges are generally made shorter and straighter than lower weight edges
};
$a209bedd1febcc34$exports = $a209bedd1febcc34$var$defaults;



const $d6d0510d416399f3$var$mockLayout = {
    emit: ()=>{},
    one: ()=>{}
};
function $d6d0510d416399f3$var$layout(graph, editor, options) {
    const eles = graph.elements();
    const baseLayer = editor._baseLayer;
    options = Object.assign({}, (0, (/*@__PURE__*/$parcel$interopDefault($a209bedd1febcc34$exports))), options);
    const bbEditor = editor.getClientRect();
    const bb = options.boundingBox || {
        x1: 0,
        y1: 0,
        w: bbEditor.width,
        h: bbEditor.height
    };
    if (bb.x2 === undefined) bb.x2 = bb.x1 + bb.w;
    if (bb.w === undefined) bb.w = bb.x2 - bb.x1;
    if (bb.y2 === undefined) bb.y2 = bb.y1 + bb.h;
    if (bb.h === undefined) bb.h = bb.y2 - bb.y1;
    const g = new (0, $3V8v7$dagre).graphlib.Graph({
        multigraph: true,
        compound: true
    });
    g.setGraph(options);
    g.setDefaultEdgeLabel(()=>({}));
    g.setDefaultNodeLabel(()=>({}));
    // add nodes to dagre
    const nodes = eles.nodes();
    nodes.forEach((node)=>{
        const nodeId = node.id();
        const dimensions = baseLayer.findOne(`#${nodeId}`).getClientRect();
        g.setNode(nodeId, {
            width: dimensions.width,
            height: dimensions.height,
            name: nodeId
        });
    });
    // set compound parents
    nodes.forEach((node)=>{
        if (!node.isChild()) return;
        g.setParent(node.id(), node.parent().id());
    });
    // add edges to dagre
    const edges = eles.edges().stdFilter((edge)=>{
        return !edge.source().isParent() && !edge.target().isParent() // dagre can't handle edges on compound nodes
        ;
    });
    edges.forEach((edge)=>{
        g.setEdge(edge.source().id(), edge.target().id(), {
            minlen: options.minLen,
            weight: options.edgeWeight,
            name: edge.id()
        }, edge.id());
    });
    (0, $3V8v7$dagre).layout(g);
    for (const id of g.nodes())graph.getElementById(id).scratch().dagre = g.node(id);
    nodes.layoutPositions($d6d0510d416399f3$var$mockLayout, options, (ele)=>{
        const { x: x , y: y  } = ele.scratch().dagre;
        return {
            x: x,
            y: y
        };
    });
    return graph;
}
var $d6d0510d416399f3$export$2e2bcd8739ae039 = $d6d0510d416399f3$var$layout;




function $f6de9593a72e305f$var$createHistory() {
    const changes = [];
    let future = [] // we will copy all undos here so we can redo these actions
    ;
    function push(action) {
        changes.push(action);
        future = [] // empty the future stack
        ;
    }
    function undo() {
        if ((0, $3V8v7$isEmpty)(changes)) return; // nothing to do
        const lastAction = changes.pop();
        lastAction.undo();
        future.push(lastAction);
    }
    function redo() {
        if ((0, $3V8v7$isEmpty)(future)) return; // nothing to redo
        const lastAction = future.pop();
        lastAction.redo();
        // copy redo action onto the changes stack
        changes.push(lastAction);
    }
    return {
        changes: changes,
        push: push,
        undo: undo,
        redo: redo // redo an action
    };
}
var $f6de9593a72e305f$export$2e2bcd8739ae039 = $f6de9593a72e305f$var$createHistory;



const $648d4508b0780f05$export$a0ac244fd9a521a9 = (meta)=>$648d4508b0780f05$var$GraphConfigurationError("ERR_CONNECT_TO_SELF", "You cannot link nodes to themselves", meta);
const $648d4508b0780f05$export$96babd1fffc1064b = (meta)=>$648d4508b0780f05$var$GraphConfigurationError("ERR_NODE_TO_ACTUATOR_NO_TRIGGER", "You cannot link a sensor to an actuator without a Transition block or state", meta);
const $648d4508b0780f05$export$a4ec5425353cc1fe = (meta)=>$648d4508b0780f05$var$GraphConfigurationError("ERR_NODE_TO_GATE_NO_TRIGGER", "You cannot link a sensor to a gate without a Transition block or state", meta);
const $648d4508b0780f05$export$724e2177b7ba2ce1 = (meta)=>$648d4508b0780f05$var$GraphConfigurationError("ERR_TOO_MANY_EDGES_TO_GATE", "You cannot link more than one state to an OR or AND gate, consider using a GENERAL gate", meta);
const $648d4508b0780f05$export$6d2e898e36a67d4 = (meta)=>$648d4508b0780f05$var$GraphConfigurationError("ERR_TOO_MANY_EDGES_TO_MEMORY_BLOCK", "You cannot link more than two states to a Transition block");
const $648d4508b0780f05$export$2037c771c760138f = (meta)=>$648d4508b0780f05$var$GraphConfigurationError("ERR_TOO_MANY_EDGES_TO_ACTUATOR", "You cannot connect multiple sensors to the same actuator");
const $648d4508b0780f05$export$17e4cc92bdd1f71d = (meta)=>$648d4508b0780f05$var$GraphConfigurationError("ERR_MEMORY_BLOCK_NOT_CONFIGURED", "Transition block is not configured yet");
const $648d4508b0780f05$export$82dda71b12126083 = (meta)=>$648d4508b0780f05$var$GraphConfigurationError("ERR_ILLEGAL_MEMORY_BLOCK_CONNECTION", "Transition blocks can only be attached to sensors or actuators");
const $648d4508b0780f05$export$cce98f22c19699af = (meta)=>$648d4508b0780f05$var$GraphConfigurationError("ERR_DUPLICATE_MEMORY_BLOCK_STATE_CONNECTION", "Transition blocks can not transition to the same states unless implicit (*)");
const $648d4508b0780f05$export$cf997f9123e6a2b0 = (meta)=>$648d4508b0780f05$var$GraphConfigurationError("ERR_NONIDENTICAL_MEMORY_BLOCK_SOURCE", "Transition blocks can only receive states from the same node");
const $648d4508b0780f05$export$67442f7bcbd45613 = (meta)=>$648d4508b0780f05$var$GraphConfigurationError("ERR_TOO_MANY_EDGES_TO_SENSOR", "You cannot connect multiple nodes to the same sensor");
function $648d4508b0780f05$var$GraphConfigurationError(code, message, meta = {}) {
    const err = new Error(message);
    err.name = "GraphConfigurationError";
    err.code = code;
    Object.assign(err, meta);
    return err;
}


const $be6c506310f3e4ab$export$a1e5e43324e56446 = "*";
const $be6c506310f3e4ab$export$25fd58f5a1c47ffa = "memoryBlock";
const $be6c506310f3e4ab$export$631b25aab344366d = "sensor";
const $be6c506310f3e4ab$export$a5e9fe3e6d57a2f = "gate";
const $be6c506310f3e4ab$export$849f07182a43661c = "actuator";
const $be6c506310f3e4ab$export$99d63451cad80451 = "states";
const $be6c506310f3e4ab$export$ed61ab6cc023899c = "always";
const $be6c506310f3e4ab$export$733ce7fd2c0097c2 = "⌘+=, ctrl+=";
const $be6c506310f3e4ab$export$572168e897f0de83 = "⌘+-, ctrl+-";
const $be6c506310f3e4ab$export$4ce5c72b71260cbd = "delete,backspace";
const $be6c506310f3e4ab$export$5f79ab3160d95130 = "⌘+z, ctrl+z";
const $be6c506310f3e4ab$export$2990ffe34b59de78 = "⌘+shift+z, ctrl+shift+z";


function $ed355f632ec0077e$export$1f2b282c216e9677(sourceNode, targetNode, state, editor) {
    const sourceType = sourceNode.data.type;
    const targetType = targetNode.data.type;
    const sourceId = sourceNode.data.id;
    const targetId = targetNode.data.id;
    const metadata = {
        sourceNode: sourceNode.data,
        targetNode: targetNode.data
    };
    // we do not allow connections to themselves
    if (sourceId === targetId) throw $648d4508b0780f05$export$a0ac244fd9a521a9(metadata);
    // we do not allow sensors or gates to be connected to actuators through a '*' state
    if (state === (0, $be6c506310f3e4ab$export$a1e5e43324e56446) && sourceType !== (0, $be6c506310f3e4ab$export$25fd58f5a1c47ffa) && targetType === (0, $be6c506310f3e4ab$export$849f07182a43661c)) throw $648d4508b0780f05$export$96babd1fffc1064b(metadata);
    // we do not allow sensors or gates to be connected to gates through a '*' state
    if (state === (0, $be6c506310f3e4ab$export$a1e5e43324e56446) && sourceType !== (0, $be6c506310f3e4ab$export$25fd58f5a1c47ffa) && targetType === (0, $be6c506310f3e4ab$export$a5e9fe3e6d57a2f)) throw $648d4508b0780f05$export$a4ec5425353cc1fe(metadata);
    // we do not allow more than one state to be connected to a gate from the same source node
    const gateType = targetNode.data.gateType;
    const edge = editor.findEdge(sourceId, targetId);
    if (targetType === (0, $be6c506310f3e4ab$export$a5e9fe3e6d57a2f) && (gateType === "OR" || gateType === "AND") && edge) throw $648d4508b0780f05$export$724e2177b7ba2ce1(metadata);
    // we cannot connect more than two states to a memoryBlock
    if (targetType === (0, $be6c506310f3e4ab$export$25fd58f5a1c47ffa) && edge && edge.data().states.length >= 2) throw $648d4508b0780f05$export$6d2e898e36a67d4(metadata);
    // you can only connect states from the same source node
    if (targetType === (0, $be6c506310f3e4ab$export$25fd58f5a1c47ffa) && (0, $3V8v7$get)(targetNode, "data.sourceId") && (0, $3V8v7$get)(targetNode, "data.sourceId") !== sourceId) throw $648d4508b0780f05$export$cf997f9123e6a2b0(metadata);
    const targetHasOneOrMoreEdges = targetNode.getEdges().length >= 1;
    // we do not allow connections from different nodes to the same actuator
    if (targetType === (0, $be6c506310f3e4ab$export$849f07182a43661c) && targetHasOneOrMoreEdges && !edge) throw $648d4508b0780f05$export$2037c771c760138f(metadata);
    if (sourceType === (0, $be6c506310f3e4ab$export$25fd58f5a1c47ffa) && !$ed355f632ec0077e$var$validMemoryBlock(sourceNode)) throw $648d4508b0780f05$export$17e4cc92bdd1f71d(metadata);
    if (sourceType === (0, $be6c506310f3e4ab$export$25fd58f5a1c47ffa) && !(targetType === (0, $be6c506310f3e4ab$export$849f07182a43661c) || targetType === (0, $be6c506310f3e4ab$export$631b25aab344366d))) throw $648d4508b0780f05$export$82dda71b12126083(metadata);
    if (targetType === (0, $be6c506310f3e4ab$export$25fd58f5a1c47ffa) && (0, $3V8v7$get)(targetNode, "data.stateFrom")) {
        const stateFrom = (0, $3V8v7$get)(targetNode, "data.stateFrom");
        const sameState = stateFrom === state;
        const anyState = stateFrom === "*";
        if (sameState && !anyState) throw $648d4508b0780f05$export$cce98f22c19699af(metadata);
    }
    // we do not allow connections from different nodes to the same sensor
    if (targetType === (0, $be6c506310f3e4ab$export$631b25aab344366d) && $ed355f632ec0077e$var$areNodesAlreadyConnected(sourceNode, targetNode, editor)) throw $648d4508b0780f05$export$67442f7bcbd45613(metadata);
}
function $ed355f632ec0077e$var$validMemoryBlock(node) {
    return (0, $3V8v7$has)(node, [
        "data",
        "stateTo"
    ]) && (0, $3V8v7$has)(node, [
        "data",
        "stateFrom"
    ]);
}
function $ed355f632ec0077e$var$areNodesAlreadyConnected(sourceNode, targetNode, editor) {
    // All good if the target doesn't have any edges yet
    if (targetNode.getEdges().length === 0) return false;
    // If source is a memory block, use the memory block's source id rather than
    // the id of the memory block itself
    const isInComingNodeMemoryBlock = (0, $3V8v7$get)(sourceNode, "data.type") === (0, $be6c506310f3e4ab$export$25fd58f5a1c47ffa);
    const inComingSourceId = isInComingNodeMemoryBlock ? sourceNode.data.sourceId : sourceNode.data.id;
    // Filter all outgoing edges from targetNode
    const targetNodeIncomingEdges = targetNode.getEdges().filter((edge)=>{
        const edgeSource = $ed355f632ec0077e$var$getEdgeSourceNode(edge, editor);
        return edgeSource !== targetNode.data.id;
    });
    // If targetNode doesn't have any incoming edges yet
    if (targetNodeIncomingEdges.length === 0) return false;
    // Check that the new incoming connection, comes from the same source
    // (directly or indirectly via memory block) as all the other already
    // configured connections.
    return targetNodeIncomingEdges.every((edge)=>{
        const edgeSource = $ed355f632ec0077e$var$getEdgeSourceNode(edge, editor);
        return edgeSource !== inComingSourceId;
    });
}
// Get edge source, if source is memory block, return source from memory block
function $ed355f632ec0077e$var$getEdgeSourceNode(edge, editor) {
    const isEdgeFromMemoryBlock = editor.getElementData(edge.data("source")).type === (0, $be6c506310f3e4ab$export$25fd58f5a1c47ffa);
    return isEdgeFromMemoryBlock ? editor.getElementData(edge.data("source")).sourceId : edge.data("source");
}




const $ea09e7ae70ac2ed1$var$CYTO_CONFIG = {
    layout: {
        name: "preset"
    },
    headless: true
};
const $ea09e7ae70ac2ed1$var$defaultOptions = {
    theme: "dark",
    controls: true,
    zoomable: true,
    draggable: true,
    editable: true,
    parser: {}
};
class $ea09e7ae70ac2ed1$var$Editor extends (0, $3V8v7$konva).Stage {
    constructor(_options){
        let { onChange: onChange = ()=>{} , ...options } = _options;
        options = (0, $3V8v7$defaults)({}, options, $ea09e7ae70ac2ed1$var$defaultOptions);
        super(options);
        this._options = options;
        this.onChange = onChange;
        // this will memoize all of the changes we've made so we can undo and redo actions
        this.history = (0, $f6de9593a72e305f$export$2e2bcd8739ae039)([]);
        // set the theme option before we call the import functions
        (0, $5c131486cc14280c$export$2e49b867b7a0847c)(options.theme);
        // this is the base layer of the editor, most everything goes here
        const layer = new (0, $3V8v7$konva).Layer();
        this._baseLayer = layer;
        this.add(layer);
        // this will hold our Cytoscape instance
        this.graph = (0, $3V8v7$cytoscape)({
            ...$ea09e7ae70ac2ed1$var$CYTO_CONFIG,
            elements: []
        });
        this._selectionGroup = (0, $bee1458cde2e54d0$export$2e2bcd8739ae039)(this._baseLayer, this);
        // edges do not need to be part of the regular selection group
        // we do not want them to be draggable
        this._curvesSelectionGroup = {};
        // we'll use this for visual debugging of the editor
        this.debugLayer = new (0, $3V8v7$konva).Layer({
            listening: false
        });
        // keep track of wether or not we are in focus mode
        this.focusMode = false;
        // this will hold functions for interactions with the container, a DOM element
        // you should not use these for firing events to the graph instance though
        this.events = {};
        // listen for window resize event to resize the container
        window.addEventListener("resize", ()=>this.fitToContainer());
        // set up container
        const container = this.container();
        // focus it
        container.tabIndex = 1;
        // also stage will be in focus on its click
        container.focus();
        container.classList.add("graph-editor__root");
        container.addEventListener("dragover", (e)=>e.preventDefault());
        // copy-paste functionality for nodes
        container.addEventListener("keydown", (e)=>{
            if (this._options.editable) {
                if (e.metaKey || e.ctrlKey) {
                    if (e.key === "c") {
                        const content = JSON.stringify(this._selectionGroup?.children?.map((element)=>{
                            return element.data;
                        }));
                        localStorage.setItem("copyContent", content);
                    }
                    if (e.key === "v") {
                        const content = localStorage.getItem("copyContent");
                        if (content && JSON.parse(content).length > 0) for (const node of JSON.parse(content)){
                            node.id = (0, $31eaad3a3400f997$export$567fc7097e064344)();
                            this._addNode({
                                data: node
                            });
                        }
                    }
                }
            }
        });
        // allow custom parser to create the graph
        this.parser = options.parser;
        if (typeof this.parser.decode !== "function") {
            const { elements: elements = []  } = options;
            this.import({
                elements: elements
            });
        }
        // instantiate the selection group should happen *before* applying the options
        this._getSelectionGroup();
        options.controls ? this._enableControls() : this._disableControls();
        options.draggable ? this._enableDrag() : this._disableDrag();
        options.zoomable ? this._enableZoom() : this._disableZoom();
        options.editable ? this.enableEdit() : this.disableEdit();
        options.selectable === false ? this._disableSelect() : this._enableSelect();
        return this;
    }
    // The selection group is a Konva Group.
    // It's used to keep track of what nodes or edges are selected by the user,
    // and because they're in a group they can be dragged together.
    _getSelectionGroup() {
        return this._selectionGroup;
    }
    _getEdgesSelectionGroup() {
        return this._curvesSelectionGroup;
    }
    getSelectedCurves() {
        return Object.values(this._getEdgesSelectionGroup());
    }
    getSelectedNodes() {
        return this._getSelectionGroup().getChildren();
    }
    _removeEventListeners() {
        const container = this.container();
        container.removeEventListener("drop", this._onDrop);
        container.removeEventListener("wheel", this._onWheel);
        (0, $3V8v7$hotkeysjs).unbind((0, $be6c506310f3e4ab$export$4ce5c72b71260cbd));
        (0, $3V8v7$hotkeysjs).unbind((0, $be6c506310f3e4ab$export$5f79ab3160d95130));
        (0, $3V8v7$hotkeysjs).unbind((0, $be6c506310f3e4ab$export$2990ffe34b59de78));
    }
    _onWheel(event) {
        event.preventDefault();
        const wheelDelta = event.wheelDelta;
        const delta = wheelDelta ? wheelDelta / 120 : event.deltaY / 3;
        const amount = Math.abs(delta) * 0.1;
        const zoomIn = delta < 0;
        if (zoomIn) this.zoomIn(amount);
        else this.zoomOut(amount);
        return false;
    }
    import(data, options) {
        if (this.graph) this.reset();
        if (typeof this.parser.decode === "function") data = this.parser.decode(data, options);
        const { elements: elements  } = data;
        this.graph = (0, $3V8v7$cytoscape)({
            ...$ea09e7ae70ac2ed1$var$CYTO_CONFIG,
            elements: elements
        });
        this._render();
    }
    export() {
        if (typeof this.parser.encode === "function") {
            const stringifiedGraph = this.graph.json(true);
            return this.parser.encode(stringifiedGraph);
        }
        return this.graph.json(true).elements.map((element)=>({
                group: element.group,
                data: element.data,
                position: element.position
            }));
    }
    _render() {
        this._baseLayer.destroyChildren();
        const nodes = this.graph.nodes();
        const edges = this.graph.edges();
        nodes.forEach((n)=>{
            const node = this._createNode(n);
            this._baseLayer.add(node);
        });
        const maxStates = edges.reduce((maxStates, e)=>{
            const target = e.target().id();
            const { states: states = [
                (0, $be6c506310f3e4ab$export$a1e5e43324e56446)
            ]  } = e.data();
            maxStates[target] = Math.max(maxStates[target] || 0, states.length);
            return maxStates;
        }, {});
        edges.forEach((e)=>{
            const source = e.source().id();
            const target = e.target().id();
            const edgeData = e.data();
            const { states: states = [
                (0, $be6c506310f3e4ab$export$a1e5e43324e56446)
            ]  } = edgeData;
            const alterStates = maxStates[target] !== states.length;
            states.forEach((state)=>this._connectNodes({
                    source: source,
                    target: target,
                    state: state,
                    data: edgeData,
                    alterStates: alterStates
                }));
        });
        const group = this._getSelectionGroup();
        group.destroyChildren();
        this._baseLayer.add(group);
        this._baseLayer.draw();
    }
    _createNode(node) {
        const data = node.data();
        const type = data.type;
        const options = {
            position: node.position(),
            editor: this
        };
        let gNode;
        switch(type){
            case "gate":
                gNode = new (0, $9e34bb6b5aa61405$export$2e2bcd8739ae039)(data, options);
                break;
            case "note":
                gNode = new (0, $89a453f9fbb0c932$export$2e2bcd8739ae039)(data, options);
                break;
            // sensors and actuators
            default:
                gNode = new (0, $e2813256b5c7265c$export$2e2bcd8739ae039)(data, options);
                break;
        }
        gNode.on("mousedown", ({ evt: { ctrlKey: ctrlKey , metaKey: metaKey , shiftKey: shiftKey  }  })=>{
            const multiSelectModeRequested = ctrlKey || metaKey || shiftKey;
            const alreadySelected = this._getSelectionGroup().findOne(`#${gNode.id()}`);
            if (!alreadySelected) {
                if (!multiSelectModeRequested) this.setSelected(null) // disable previous selection
                ;
                this.setSelected(gNode);
                return true;
            }
            if (multiSelectModeRequested) this._unselect(gNode);
        });
        return gNode;
    }
    getNodeConfigurations() {
        return this.graph.nodes().reduce((acc, node)=>{
            const config = (0, $3V8v7$get)(node.data(), "configuration.properties");
            if (config) acc.set(node.id(), config);
            return acc;
        }, new Map());
    }
    _addNode(node = {
        data: {}
    }) {
        const graphicalNode = this.__addNode(node);
        this.history.push({
            op: "_addNode",
            undo: ()=>this._deleteNode(node.data.id),
            redo: ()=>this.__addNode(node)
        });
        const addedNode = this.graph.getElementById(node.data.id);
        this.fire("nodeAdded", {
            node: addedNode,
            graphicalNode: graphicalNode
        });
    }
    // TODO validate input
    __addNode(node = {
        data: {}
    }) {
        this.onChange();
        if (!node.data.id) Object.assign(node.data, {
            id: (0, $31eaad3a3400f997$export$567fc7097e064344)()
        });
        const cNode = this.graph.add(node);
        const gNode = this._createNode(cNode);
        this._baseLayer.add(gNode).draw();
        // _unselect the previous selected node
        this.resetSelected();
        this.setSelected(gNode);
        return gNode;
    }
    _addNote(node) {
        const { data: data , ...options } = node;
        const graphNode = new (0, $89a453f9fbb0c932$export$2e2bcd8739ae039)(data, options);
        this._baseLayer.add(graphNode).draw();
        return graphNode;
    }
    _deleteCurves(ids) {
        this.onChange();
        return ids.map((id)=>this._deleteCurve(id));
    }
    _deleteSelectedElements() {
        const selectedNodes = this.getSelectedNodes();
        const selectedNodeIds = selectedNodes.map((n)=>n.data.id);
        const graphNodes = selectedNodeIds.map((id)=>this.graph.getElementById(id));
        const connectedEdges = graphNodes.map((el)=>el.connectedEdges().toArray()).flat().map((edge)=>{
            const { source: source , target: target , states: states = [] , ...data } = edge.data();
            return {
                source: source,
                target: target,
                states: states,
                data: data
            };
        });
        const connectedCurvesIds = connectedEdges// these curves are not part of the curve class, these are the children of an edge
        // so we cannot use getId here
        .flatMap(({ data: data  })=>data.curves.map((curve)=>curve._id));
        // other selected edges
        const selectedCurves = this.getSelectedCurves();
        // remove curves that are already existing in the connectedEdges or vice versa
        const filteredCurves = selectedCurves.filter((c)=>!connectedCurvesIds.includes(c.getId()));
        const sameCurves = selectedCurves.filter((c)=>connectedCurvesIds.includes(c.getId()));
        // deselect the intersection between selected and connected edges
        sameCurves.forEach((c)=>c.setSelected(false));
        const elements = {
            nodeIds: selectedNodeIds,
            curveIds: filteredCurves.map((c)=>c.getId())
        };
        this._deleteElements(elements);
    }
    _deleteElements({ curveIds: curveIds , nodeIds: nodeIds  }) {
        this.onChange();
        const deletedCurves = this._deleteCurves(curveIds);
        const graphNodes = nodeIds.map((id)=>this.graph.getElementById(id));
        const graphEdges = graphNodes.map((el)=>el.connectedEdges().toArray()).flat();
        const undoData = graphEdges.map((edge)=>{
            const { source: source , target: target , states: states = [] , ...data } = edge.data();
            return {
                source: source,
                target: target,
                states: states,
                data: data
            };
        });
        this.history.push({
            op: "deleteNode",
            undo: ()=>{
                const nodes = graphNodes.map((n)=>this.__addNode(n));
                undoData.forEach((item)=>{
                    const { source: source , target: target , states: states = [] , data: data  } = item;
                    states.forEach((state)=>this.connectNodes(source, target, state, data));
                });
                nodes.forEach((n)=>this.setSelected(n));
                deletedCurves.forEach((curve)=>{
                    const { source: source , target: target , states: states = [] , ...data } = curve.data();
                    const clonedData = {
                        ...data,
                        _id: curve.getId()
                    };
                    states.forEach((state)=>this.connectNodes(source, target, state, clonedData));
                });
                this.batchDraw();
            },
            redo: ()=>{
                this._deleteCurves(curveIds);
                nodeIds.forEach((id)=>this._deleteNode(id));
            }
        });
        nodeIds.forEach((id)=>this._deleteNode(id));
        graphNodes.forEach((node)=>this.fire("nodeDeleted", {
                node: node
            }));
    }
    _deleteNode(id) {
        this.onChange();
        // Update graph
        this._disconnectAllStates(id);
        const graphNode = this.graph.getElementById(id);
        this.graph.remove(graphNode);
        // Update UI
        this.setSelected(null);
        this.container().style.cursor = "default";
        this._findGraphicalNodeById(id).destroy();
        this._baseLayer.draw();
    }
    _deleteCurve(id) {
        this.onChange();
        const curve = this._curvesSelectionGroup[id];
        curve.setSelected(false);
        const startNode = curve.startHandle.findAncestor(".node").id();
        const endNode = curve.endHandle.findAncestor(".node").id();
        const isImplicitState = curve.startHandle.name() === "rightHandle";
        const state = isImplicitState ? "*" : curve.startHandle.state;
        this.disconnectNodes(startNode, endNode, state);
        this._baseLayer.draw();
        return curve;
    }
    focusState(source, state) {
        const sourceNode = this._findNodeByLabel(source);
        sourceNode.focusState(state);
        this._baseLayer.batchDraw();
    }
    // this function differs from focusState in that it disables all other states
    focusSingleState(source, state) {
        this._unfocusAllStates(source);
        this.focusState(source, state);
    }
    unfocusState(source, state) {
        const sourceNode = this._findNodeByLabel(source);
        sourceNode.unfocusState(state);
        this._baseLayer.batchDraw();
    }
    // disable focus of all states
    _unfocusAllStates(source) {
        const sourceNode = this._findNodeByLabel(source);
        sourceNode.find((node)=>node.name().includes("stategroup:")).forEach((group)=>group.unfocus());
        this._baseLayer.batchDraw();
    }
    // this function will reset all of the focused states of all nodes in the graph
    resetAllFocusedStates() {
        this.graph.nodes().forEach((node)=>this._unfocusAllStates(node.data("label")));
    }
    // DO NOT use this function unless you really need it, will be replaced with NodeId later
    // TODO this is a dirty workaround until we figure out what a NodeId is
    _findNodeByLabel(label) {
        const nodes = this._baseLayer.find(".node");
        const sourceNode = (0, $3V8v7$find)(nodes, (node)=>node.data.label === label);
        return sourceNode;
    }
    // connect two nodes via a state; either implicit (*) or explicit
    connectNodes(source, target, state, data = {}) {
        this.onChange();
        const sourceNode = this._baseLayer.findOne(`#${source}`);
        const targetNode = this._baseLayer.findOne(`#${target}`);
        // validate if we are allowed to make this connection
        try {
            (0, $ed355f632ec0077e$export$1f2b282c216e9677)(sourceNode, targetNode, state, this);
        } catch (error) {
            const stateAlreadyConnected = sourceNode.hasConnectedState(state);
            // do not deactivate the state if it has a valid connection to another node
            if (!stateAlreadyConnected) sourceNode.deactivateState(state);
            this.fire("error", {
                error: error
            });
            return;
        }
        this._connectNodes({
            source: source,
            target: target,
            state: state,
            data: data
        });
    }
    // connectNodes without validation
    _connectNodes({ source: source , target: target , state: state , data: data = {} , alterStates: alterStates = true  }) {
        // --- Update UI ---
        const sourceNode = this._baseLayer.findOne(`#${source}`);
        const targetNode = this._baseLayer.findOne(`#${target}`);
        // activate the state on the source node
        if (state !== (0, $be6c506310f3e4ab$export$a1e5e43324e56446)) sourceNode.activateState(state);
        // if the edge is connected to a MemoryBlock as the target,
        // draw a dashed line to indicate it is involved in the stateChange decision
        const toMemoryBlock = targetNode.data.type === (0, $be6c506310f3e4ab$export$25fd58f5a1c47ffa);
        const fromMemoryBlock = sourceNode.data.type === (0, $be6c506310f3e4ab$export$25fd58f5a1c47ffa);
        if (fromMemoryBlock || toMemoryBlock) return this._connectMemoryBlock(sourceNode, targetNode, state);
        // figure out the triggerType based on the state and the target node
        let triggerType = data.triggerType;
        const targetType = targetNode.data.type;
        if (!triggerType) {
            if (state === (0, $be6c506310f3e4ab$export$a1e5e43324e56446) && targetType === (0, $be6c506310f3e4ab$export$631b25aab344366d)) triggerType = (0, $be6c506310f3e4ab$export$ed61ab6cc023899c);
            else triggerType = (0, $be6c506310f3e4ab$export$99d63451cad80451);
        }
        // Get edge, it should have one or multiple curves
        const edge = this.findEdge(source, target);
        const drawCurve = (curve)=>{
            if (!curve) return; // noop
            // curve needs to be cloned with same _id
            if (data._id) curve.setId(data._id);
            this._baseLayer.add(curve);
            curve.moveToBottom();
            this._baseLayer.batchDraw();
        };
        // first connection between two nodes, either with implicit or explicit state
        if (!edge) {
            const curve = this._createEdge({
                sourceNode: sourceNode,
                targetNode: targetNode,
                state: state,
                data: {
                    triggerType: triggerType
                }
            });
            drawCurve(curve);
            return;
        }
        // if we make it all the way here, it means we are adding another state and curve
        // to the existing edge
        const { states: states = []  } = edge.data();
        const goToAnyState = state === (0, $be6c506310f3e4ab$export$a1e5e43324e56446) && states.length > 0;
        const goFromAnyStateToStates = state !== (0, $be6c506310f3e4ab$export$a1e5e43324e56446) && states.includes("*");
        // we cannot support both 'always' state and any other state combination
        // so we disconnect the existing states if we connect an ANY state to a sensor
        if (goToAnyState) {
            states.forEach((state)=>this.disconnectNodes(source, target, state));
            this.connectNodes(source, target, (0, $be6c506310f3e4ab$export$a1e5e43324e56446));
        } else if (goFromAnyStateToStates) {
            states.forEach((state)=>this.disconnectNodes(source, target, state));
            this.connectNodes(source, target, state);
        } else {
            const curve = this._updateEdge({
                sourceNode: sourceNode,
                targetNode: targetNode,
                state: state,
                alterStates: alterStates
            });
            drawCurve(curve);
        }
    }
    _findGraphicalNodeById(id) {
        return this._baseLayer.findOne(`#${id}`);
    }
    findNodeById(id) {
        return this.graph.getElementById(id);
    }
    findEdgeById(id) {
        return this.graph.getElementById(id);
    }
    _findGraphicalEdgeById(id) {
        return this._baseLayer.findOne(`#${id}`);
    }
    findEdge(source, target) {
        const edge = this.graph.edges().filter((edge)=>{
            const { source: edgeSource , target: edgeTarget  } = edge.data();
            return edgeSource === source && edgeTarget === target;
        }).first();
        return edge.length > 0 ? edge : undefined;
    }
    _createEdge({ sourceNode: sourceNode , targetNode: targetNode , state: state , data: data = {}  }) {
        this.onChange();
        const [sourceHandle, targetHandle] = this._getHandlesFromNodes(sourceNode, targetNode, state);
        const curve = new (0, $c17607a58ba3b426$export$2e2bcd8739ae039)(sourceHandle, targetHandle, {
            editor: this
        }, data);
        // GENERAL gate can support duplicate states, we draw them as dashed lines
        // because they contribute to evaluating the target node but do not evaluate
        // the target node when the state is active
        const toGeneralGate = (0, $3V8v7$matches)({
            type: "gate",
            gateType: "GENERAL"
        })(targetNode.data);
        if (toGeneralGate) curve.dash([
            10,
            5
        ]);
        this.graph.add({
            group: "edges",
            data: {
                id: (0, $31eaad3a3400f997$export$567fc7097e064344)(),
                source: sourceNode.data.id,
                target: targetNode.data.id,
                states: [
                    state
                ],
                curves: [
                    curve
                ],
                ...data
            }
        });
        return curve;
    }
    _updateEdge({ sourceNode: sourceNode , targetNode: targetNode , state: state , alterStates: alterStates  }) {
        this.onChange();
        const [sourceHandle, targetHandle] = this._getHandlesFromNodes(sourceNode, targetNode, state);
        const edge = this.findEdge(sourceNode.data.id, targetNode.data.id);
        const { states: states = [] , curves: curves = [] , triggerType: triggerType  } = edge.data();
        const curve = new (0, $c17607a58ba3b426$export$2e2bcd8739ae039)(sourceHandle, targetHandle, {
            editor: this
        }, edge.data());
        // GENERAL gate can support duplicate states, we draw them as dashed lines
        // because they contribute to evaluating the target node but do not evaluate
        // the target node when the state is active
        const toGeneralGate = (0, $3V8v7$matches)({
            type: "gate",
            gateType: "GENERAL"
        })(targetNode.data);
        if (toGeneralGate) curve.dash([
            10,
            5
        ]);
        // if the curve already exists we skip drawing it multiple times
        const curveExists = curves.some((c)=>c.startHandle.name() + c.endHandle.name() === curve.startHandle.name() + curve.endHandle.name());
        // only GENERAL gate should allow multiple of the same states to be connected on the same edge
        const newStates = toGeneralGate ? alterStates ? [
            ...states,
            state
        ] : states : (0, $3V8v7$uniq)([
            ...states,
            state
        ]);
        const newCurves = (0, $3V8v7$uniqBy)([
            ...curves,
            curve
        ], (c)=>c.startHandle.name() + c.endHandle.name());
        edge.data({
            states: newStates,
            curves: newCurves,
            triggerType: triggerType
        });
        return curveExists ? null : curve;
    }
    _getHandlesFromNodes(sourceNode, targetNode, state) {
        const sourceHandle = state ? sourceNode.getStateHandle(state) : sourceNode.getRightHandle();
        const targetHandle = targetNode.getLeftHandle();
        return [
            sourceHandle,
            targetHandle
        ];
    }
    // connect states from source to memoryblock and from memoryblock to target
    _connectMemoryBlock(sourceNode, targetNode, state) {
        this.onChange();
        const memoryBlock = [
            sourceNode,
            targetNode
        ].find((n)=>n.data.type === (0, $be6c506310f3e4ab$export$25fd58f5a1c47ffa));
        const toMemoryBlock = memoryBlock === targetNode;
        // automatically place the memoryBlock when we have no user-defined position
        // and when we are the source node
        if (memoryBlock === sourceNode) {
            const memoryPos = memoryBlock.position();
            const noPosition = memoryPos.x === 0 && memoryPos.y === 0;
            // if the memory node has [0,0] coordinates we assume it has not been manually positioned
            if (noPosition) {
                const memoryRect = memoryBlock.getClientRect();
                const targetRect = targetNode.getClientRect();
                const targetPos = targetNode.position();
                // the 50 pixels are kind of arbitrary but it has to be larger than the ICON_SIZE
                const newX = targetPos.x - targetRect.width / 2 - memoryRect.width / 2 - 50;
                memoryBlock.position({
                    x: newX,
                    y: targetPos.y
                });
                memoryBlock.updateEdges();
            }
        }
        const existingEdge = this.findEdge(sourceNode.data.id, targetNode.data.id);
        const curve = existingEdge ? this._updateEdge({
            sourceNode: sourceNode,
            targetNode: targetNode,
            state: state
        }) : this._createEdge({
            sourceNode: sourceNode,
            targetNode: targetNode,
            state: state
        });
        const sourceId = sourceNode.data.id;
        const targetId = targetNode.data.id;
        const drawLine = drawCurve.bind(this);
        // add dash style to the curve if we are connecting to a memory block
        if (toMemoryBlock) {
            this.updateElementData(targetId, {
                sourceId: sourceId
            });
            if (existingEdge) {
                const { states: states = []  } = existingEdge.data();
                memoryBlock.updateProp("label", `${states[0]} → ${state}`);
                this.updateElementData(targetId, {
                    stateTo: state
                });
            } else {
                memoryBlock.updateProp("label", `${state} → ?`);
                this.updateElementData(targetId, {
                    stateFrom: state
                });
            }
            // curve can be null when we're doing a "* to *" connection
            if (curve) drawLine(curve);
            // Ok so, ... *deep breath*
            // We're basically connecting all states to the memory block
            // but since we only want to visualize the "from" state
            // we disconnect the "to" state visually after drawing it
            if (existingEdge && existingEdge.data("curves").length === 2) {
                const { states: states = []  } = existingEdge.data();
                this.disconnectNodes(sourceId, targetId, states[1]);
            }
        } else {
            // we assume fromMemoryBlock
            this.updateElementData(sourceId, {
                targetId: targetId
            });
            drawLine(curve);
        }
        // draw the actual curve
        function drawCurve(curve) {
            curve.dash([
                10,
                5
            ]);
            this._baseLayer.add(curve);
            curve.moveToBottom();
        }
    }
    _disconnectAllStates(id) {
        this.onChange();
        const graphNode = this.graph.getElementById(id);
        const graphEdges = graphNode.connectedEdges();
        graphEdges.forEach((edge)=>{
            const { source: source , target: target , states: states = []  } = edge.data();
            const targetNode = this.findNodeById(target);
            const targetIsMemoryBlock = targetNode.data("type") === "memoryBlock";
            states.forEach((state)=>{
                this.disconnectNodes(source, target, state);
                /**
         * Clean up memory block linked to selected node. If selected node is
         * memory block itself, don't remove it.
         */ if (targetIsMemoryBlock && id !== target) this._deleteNode(target);
            });
        });
    }
    disconnectNodes(source, target, state) {
        this.onChange();
        // deactivate the state handle
        const node = this.findOne(`#${source}`);
        node.deactivateState(state);
        const edge = this.graph.edges().filter((e)=>{
            const { source: edgeSource , target: edgeTarget  } = e.data();
            return edgeSource === source && edgeTarget === target;
        }).first();
        // this edge has already been cleaned up
        if (edge.length === 0) return;
        const { states: states = [] , curves: curves = []  } = edge.data();
        const explicitState = state !== (0, $be6c506310f3e4ab$export$a1e5e43324e56446);
        const handleName = explicitState ? `state:${state}` : "rightHandle";
        // destroy the curve
        const curve = curves.find((c)=>c.startHandle.name() === encodeURI(handleName));
        // curve can be undefined if we have a state defined multiple times
        if (curve) {
            curve.off() // destroy event listeners
            ;
            curve.destroy();
        }
        // calculate the new array of states and curves for the edge
        const newStates = (0, $3V8v7$reject)(states, (s)=>s === state);
        const newCurves = curve ? (0, $3V8v7$reject)(curves, curve) : curves;
        edge.data({
            states: newStates,
            curves: newCurves
        });
        // remove the edge if we have no more states connected
        if ((0, $3V8v7$isEmpty)(newStates)) this.graph.remove(edge);
        this._baseLayer.draw();
    }
    fitToContainer() {
        const container = this.container();
        const { clientWidth: width , clientHeight: height  } = container;
        this.width(width);
        this.height(height);
        this.batchDraw();
    }
    getElementData(id) {
        const element = this.graph.getElementById(id);
        return element.data();
    }
    setSelected(node) {
        if (!node) return this._unselect();
        const { data: data  } = node;
        const graphicalNode = this._findGraphicalNodeById(data.id);
        node.setSelected(true);
        // detach the element from the baseLayer and attach it to the drag group
        node.remove();
        this._getSelectionGroup().add(node);
        this.fire("nodeFocus", {
            node: data,
            graphicalNode: graphicalNode
        });
    }
    _selectCurve(curve) {
        this._getEdgesSelectionGroup()[curve.getId()] = curve;
    }
    _unselectCurve(curve) {
        const newEdges = this._getEdgesSelectionGroup();
        delete newEdges[curve.getId()];
        this._curvesSelectionGroup = newEdges;
    }
    _unselect(nodeOrEdge) {
        if (!nodeOrEdge) {
            this.getSelectedNodes().forEach((n)=>this._unselect(n));
            this.getSelectedCurves().forEach((c)=>this._unselect(c));
            return;
        }
        const { data: data  } = nodeOrEdge;
        const graphicalNode = this._findGraphicalNodeById(data.id);
        nodeOrEdge.setSelected(false);
        // detach the element from the drag group and attach it to the baseLayer again
        nodeOrEdge.remove();
        this._baseLayer.add(nodeOrEdge);
        this.fire("nodeBlur", {
            node: data,
            graphicalNode: graphicalNode
        });
    }
    updateLabel(id, text) {
        const graphicalNode = this._findGraphicalNodeById(id);
        if (!graphicalNode) throw new Error(`No node with id ${id} found`);
        graphicalNode.updateLabel(text);
    }
    updateNodeLabels(id, labels) {
        const graphicalNode = this._findGraphicalNodeById(id);
        if (!graphicalNode) throw new Error(`No node with id ${id} found`);
        graphicalNode.updateNodeLabels(labels);
    }
    deleteAnnotation(id, annotation) {
        const graphicalNode = this._findGraphicalNodeById(id);
        if (!graphicalNode) throw new Error(`No node with id ${id} found`);
        graphicalNode.deleteAnnotation(annotation);
    }
    addAnnotation(id, annotation) {
        const graphicalNode = this._findGraphicalNodeById(id);
        if (!graphicalNode) throw new Error(`No node with id ${id} found`);
        graphicalNode.addAnnotation(annotation);
    }
    updateElementData(id, data = {}) {
        if ((0, $3V8v7$isEmpty)(data)) return;
        const element = this.graph.getElementById(id);
        element.data(data);
    }
    updateElementPosition(id, position) {
        if ((0, $3V8v7$isEmpty)(position)) return;
        // Eliminate floating point coordinates
        const roundedPosition = (0, $3V8v7$reduce)(position, (acc, value, key)=>{
            acc[key] = Math.round(value);
            return acc;
        }, {
            x: 0,
            y: 0
        });
        const element = this.graph.getElementById(id);
        element.position(roundedPosition);
    }
    resetSelected() {
        this._unselect(null);
    }
    zoomIn(amount = 0.1) {
        const oldScale = this.scaleX();
        const newScale = Math.min(oldScale + amount, 1.5);
        if (this.getPointerPosition()) this._updateRelativeZoomPosition(oldScale, newScale);
        this.scale({
            x: newScale,
            y: newScale
        });
        this.batchDraw();
    }
    zoomOut(amount = 0.1) {
        const oldScale = this.scaleX();
        const newScale = Math.max(oldScale - amount, 0.5);
        if (this.getPointerPosition()) this._updateRelativeZoomPosition(oldScale, newScale);
        this.scale({
            x: newScale,
            y: newScale
        });
        this.batchDraw();
    }
    // use cursor location for zooming in or out
    _updateRelativeZoomPosition(oldScale, newScale) {
        const mousePointTo = {
            x: this.getPointerPosition().x / oldScale - this.x() / oldScale,
            y: this.getPointerPosition().y / oldScale - this.y() / oldScale
        };
        const newPos = {
            x: -(mousePointTo.x - this.getPointerPosition().x / newScale) * newScale,
            y: -(mousePointTo.y - this.getPointerPosition().y / newScale) * newScale
        };
        this.setPosition(newPos);
    }
    getAbsolutePointerPosition() {
        const { x: x , y: y  } = this.getPointerPosition();
        const transform = this.getAbsoluteTransform().copy().invert();
        const translation = transform.getTranslation();
        const scale = transform.getMatrix()[0];
        return {
            x: x * scale + translation.x,
            y: y * scale + translation.y
        };
    }
    reset() {
        this._baseLayer.destroyChildren().draw();
        this.graph.destroy();
        this.graph = (0, $3V8v7$cytoscape)({
            ...$ea09e7ae70ac2ed1$var$CYTO_CONFIG,
            elements: []
        });
    }
    _onDrop(event) {
        const { pageX: pageX , pageY: pageY , dataTransfer: dataTransfer  } = event;
        const { top: top , left: left  } = this.container().getBoundingClientRect();
        const { node: node  } = JSON.parse(dataTransfer.getData("data"));
        const position = (0, $31eaad3a3400f997$export$373663db9c61461e)(this, {
            x: pageX - left,
            y: pageY - top
        });
        this._addNode({
            ...node,
            position: position
        });
    }
    // this function auto-layouts the graph and rerenders the editor
    layout(options = {}) {
        const { _baseLayer: baseLayer , graph: graph  } = this;
        (0, $d6d0510d416399f3$export$2e2bcd8739ae039)(graph, this, options) // apply dagre layout
        ;
        graph.nodes().forEach((node)=>{
            const nodeId = node.id();
            const gNode = this._baseLayer.findOne(`#${nodeId}`);
            const newPosition = graph.getElementById(nodeId).position();
            gNode.position(newPosition);
            gNode.updateEdges();
        });
        baseLayer.draw();
    }
    /**
   * Controls
   */ _enableControls() {
        this.controls = (0, $ddc0da5ca7921d57$export$2e2bcd8739ae039)(this);
        this.container().append(this.controls);
    }
    _disableControls() {
        if (this.controls) this.controls.remove();
    }
    /**
   * Editing the visual graph
   */ enableEdit() {
        const container = this.container();
        this._baseLayer.listening(true);
        this.events.onDrop = (e)=>this._onDrop(e);
        container.addEventListener("drop", this.events.onDrop);
        (0, $3V8v7$hotkeysjs)((0, $be6c506310f3e4ab$export$4ce5c72b71260cbd), (e)=>{
            e.preventDefault();
            this._deleteSelectedElements();
        });
        (0, $3V8v7$hotkeysjs)((0, $be6c506310f3e4ab$export$5f79ab3160d95130), (e)=>{
            e.preventDefault();
            this.history.undo();
        });
        (0, $3V8v7$hotkeysjs)((0, $be6c506310f3e4ab$export$2990ffe34b59de78), (e)=>{
            e.preventDefault();
            this.history.redo();
        });
        const selectionGroup = this._getSelectionGroup();
        selectionGroup.draggable(true);
        selectionGroup.listening(true);
        this._enableSelect();
    }
    disableEdit() {
        const container = this.container();
        const selectionGroup = this._getSelectionGroup();
        selectionGroup.draggable(false);
        selectionGroup.listening(false);
        container.removeEventListener("drop", this.events.onDrop);
        this._disableSelect();
    }
    _enableSelect() {
        this._baseLayer.listening(true);
        this.on("mousedown", ({ target: target  })=>{
            const shouldResetSelected = (this.getSelectedNodes().length || this.getSelectedCurves().length) && target.nodeType === "Stage";
            if (shouldResetSelected) this.resetSelected();
        });
    }
    _disableSelect() {
        this._baseLayer.listening(false);
        this.off("mousedown");
    }
    /**
   * Zooming
   */ _enableZoom() {
        (0, $3V8v7$hotkeysjs)((0, $be6c506310f3e4ab$export$733ce7fd2c0097c2), (e)=>{
            e.preventDefault();
            this.zoomIn();
        });
        (0, $3V8v7$hotkeysjs)((0, $be6c506310f3e4ab$export$572168e897f0de83), (e)=>{
            e.preventDefault();
            this.zoomOut();
        });
        this.events.onWheel = (e)=>this._onWheel(e);
        this.container().addEventListener("wheel", this.events.onWheel);
    }
    _disableZoom() {
        (0, $3V8v7$hotkeysjs).unbind((0, $be6c506310f3e4ab$export$733ce7fd2c0097c2));
        (0, $3V8v7$hotkeysjs).unbind((0, $be6c506310f3e4ab$export$572168e897f0de83));
        this.container().removeEventListener("wheel", this.events.onWheel);
    }
    /**
   * Dragging
   */ _enableDrag() {
        this.setDraggable(true);
    }
    _disableDrag() {
        this.setDraggable(false);
    }
}
var $ea09e7ae70ac2ed1$export$2e2bcd8739ae039 = $ea09e7ae70ac2ed1$var$Editor;


export {$ea09e7ae70ac2ed1$export$2e2bcd8739ae039 as default};
//# sourceMappingURL=editor.esm.js.map
